<!--US Page-->
<div class="dtfuseAndPrivacy" *ngIf="!isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Terms-Privacy_Header.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle" style="text-align:center;padding: 150px;">
        {{ 'TermsOfUse.TermsPrivacyTitle' | translate }}
      </h2>
     
    </section>
  </section>

  <section class='mbfs-repay-banner-inner' style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
        <h4 style="text-align:left ;padding-top: 81px; padding-left: 81px;">
          {{ 'TermsOfUse.TermsPrivacyHeader' | translate }}
        </h4>
        <p class="mbfs-repay-banner-inner__header-text2" style="text-align:left ; padding-left: 81px;padding-right: 81px;">{{ 'TermsOfUse.TermsPrivacyCopy1' |
          translate }}</p>
        <p class="mbfs-repay-banner-inner__header-text2" style="text-align:left ; padding-bottom: 15px; padding-left: 81px;padding-right: 81px;">{{ 'TermsOfUse.TermsPrivacyCopy2' |
          translate }}</p>
  </section>

  
        <div class="mbfs-repay-banner-inner__header-text2" style="padding-top: 21px; padding-bottom: 15px; padding-left: 81px;  padding-right: 81px;">
            <b>{{ 'TermsOfUse.TermsPrivacyCopy3' | translate}}</b><br><br>
 <p>{{ 'TermsOfUse.TermsPrivacyCopy4' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy5' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy6' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy7' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy9' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy10' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy11' | translate }}</b><br><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy12' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy13' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy14' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy15' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy16' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy17' | translate }}</p>
      <div  style="display:flex;"><b  style="text-align:left ;padding-right: 15px;">A.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy18' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">B.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy19' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">C.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy21' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">D.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy22' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">E.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy23' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">F.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy24' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">G.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy25' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">H.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy26' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">I.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy27' | translate }}</p><br>
      </div>
      <div  style="display:flex;"><b style="text-align:left ;padding-right: 15px;">J.</b>
        <p>{{ 'TermsOfUse.TermsPrivacyCopy28' | translate }}</p><br>
      </div><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy29' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy30' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy31' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy32' | translate }}</p><br>
      <p >{{ 'TermsOfUse.TermsPrivacyCopy33' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy34' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy35' | translate }}</p><br>
      <div>
        <p>By your usage of this web site, you agree to release Daimler
          Truck Financial Services USA LLC and its affiliates (including subsidiaries, agents, officers, directors,
          employees, and insurers) from any claims, demands, and damages of every kind and nature, known and unknown,
          arising out of or in any way connected to the use or attempted use of this web site. User hereby waives
          California Civil Code section 1542, which states that:
          <b>"a general release does not extend to claims which the creditor does not know or suspect to exist in his or
            her favor at the time of executing the release, which if known by him or her must have materially affected
            his or her settlement with the debtor."</b>user also waives any provision of the statutory or nonstatutory
          law of any jurisdiction that is similar in wording or effect to California Civil Code section 1542.
        </p>
      </div>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy39' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy40' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy41' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy42' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy43' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy44' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy45' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy46' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy47' | translate }}</p><br>
      <b><u>{{ 'TermsOfUse.TermsPrivacyCopy48' | translate }}</u></b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy49' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy50' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy51' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy52' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy53' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy54' | translate }}</p><br>
      <b><u>{{ 'TermsOfUse.TermsPrivacyCopy55' | translate }}</u></b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy56' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy57' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy58' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy59' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy60' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy61' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy62' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy63' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy64' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy65' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy67' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy68' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy69' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy70' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy71' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy72' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy73' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy74' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy75' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy76' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy77' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy78' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy79' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy80' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy81' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy82' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy83' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy84' | translate }}</p><br>
      <p><u>{{ 'TermsOfUse.TermsPrivacyCopy85' | translate }}</u></p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy86' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy87' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy88' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy89' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy90' | translate }}</p>
      <p >{{ 'TermsOfUse.TermsPrivacyCopy91' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy92' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy93' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy94' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy95' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy96' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy97' | translate }}</b><br><br>
      <p >{{ 'TermsOfUse.TermsPrivacyCopy98' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy99' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy1' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy2' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy3' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy4' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy5' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy6' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy7' | translate }}</p>
     <p>{{ 'TermsOfUse.TermsPrivacy8' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacy9' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacy10' | translate }}</p><br>
      
      <p><b>{{ 'TermsOfUse.TermsPrivacy11' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy12' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacy13' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacy14' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy15' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy16' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy17' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy18' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy19' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy20' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy21' | translate }}</p><br>
     <p> <b >{{ 'TermsOfUse.TermsPrivacy22' | translate }}</b></p>
      <p><b>{{ 'TermsOfUse.TermsPrivacy23' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy24' | translate }}</p>
      <p> <b>{{ 'TermsOfUse.TermsPrivacy25' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy26' | translate }}</p>
      <p> <b>{{ 'TermsOfUse.TermsPrivacy27' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy28' | translate }}</p>
      <p> <b>{{ 'TermsOfUse.TermsPrivacy29' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy30' | translate }}</p>
      <p> <b>{{ 'TermsOfUse.TermsPrivacy31' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy32' | translate }}</p>
      <p> <b >{{ 'TermsOfUse.TermsPrivacy33' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacy34' | translate }}</p>
      <p> <b>{{ 'TermsOfUse.TermsPrivacy35' | translate }}</b></p>
      <p >{{ 'TermsOfUse.TermsPrivacy36' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacy37' | translate }}</b><br><br>
      <p>{{ 'TermsOfUse.TermsPrivacy38' | translate }}</p><br>
      <p>{{ 'TermsOfUse.TermsPrivacy39' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy40' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy41' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy42' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy43' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy44' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy45' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy46' | translate }}</p>
      <p>Our practices with regard to your information are disclosed to you in this statement, as well as any other point your personal information is collected and can be referred to on our website. You may submit a verified request to know or delete your personal information to us online through this link  ›<a class="mbfs-footer-nav-items" href="{{this.localRedirect}}/home/ccpa"> <u style="color:#00566A">California consumer privacy act</u></a> in our privacy policy or directly on our website. You may also submit your request through our dedicated CCPA agent line at (866) 429-3646. They are available to answer questions or concerns regarding our privacy practices and policies or about how to submit a request.</p>
      <p >{{ 'TermsOfUse.TermsPrivacy47' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacy48' | translate }}</p>
    </div>
  </div>
 

<!--Canada Page-->

<div class="dtfuseAndPrivacy" *ngIf="isCanadaPortal">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <!--Banner-->
  <section class="mbfs-home-hero"
    style="background-image: url(/static/assets/img/dtf-assets/images/redesign/DTF_Terms-Privacy_Header.jpg);">
    <section class="mbfs-home-hero__header">
      <h2 class="mbfs-home-hero__header-subtitle" style="text-align:center;padding: 150px;">
        {{ 'TermsOfUse.TermsPrivacyTitle' | translate }}
      </h2>
     
    </section>
  </section>

  <section class='mbfs-repay-banner-inner' style="padding-top: 21px; padding-bottom: 15px; padding-left: 21px;">
        <h4 style="text-align:left ;padding-top: 81px; padding-left: 81px;">
          {{ 'TermsOfUse.TermsPrivacyHeader' | translate }}
        </h4>
        
  </section>
  
  
  <div class="mbfs-repay-banner-inner__header-text2" style="padding-top: 21px; padding-bottom: 15px; padding-left: 81px;  padding-right: 81px;">
          <p class="mbfs-repay-banner-inner__header-text2">{{ 'TermsOfUse.TermsPrivacyCopy1' | translate }}</p>
          <p>{{ 'TermsOfUse.TermsPrivacyCopy3' | translate}}</p>
          <div style="display: flex;">
 <p>{{ 'TermsOfUse.TermsPrivacyCopy4' | translate }}
 <a *ngIf="!isFrench" href="https://daimler-truckfinancial.com/ca/en/home"><u>{{ 'TermsOfUse.TermsPrivacyCopy79' | translate }}</u></a>
 <a *ngIf="isFrench" href="https://daimler-truckfinancial.com/ca/fr/home"><u>{{ 'TermsOfUse.TermsPrivacyCopy79' | translate }}</u></a>
 {{ 'TermsOfUse.TermsPrivacyCopy80' | translate }}</p>
</div>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy5' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy6' | translate }}</b><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy7' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy9' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy10' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy11' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy12' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy13' | translate }}</b><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy14' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy15' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy16' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy17' | translate }}</p>
     <p>{{ 'TermsOfUse.TermsPrivacyCopy18' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy19' | translate }}</p>
     <p>{{ 'TermsOfUse.TermsPrivacyCopy21' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy22' | translate }}</p>
     <p>{{ 'TermsOfUse.TermsPrivacyCopy23' | translate }}</p>
     <p>{{ 'TermsOfUse.TermsPrivacyCopy24' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy26' | translate }}</b><br>
     <p>{{ 'TermsOfUse.TermsPrivacyCopy27' | translate }}</p><br>
       <b>{{ 'TermsOfUse.TermsPrivacyCopy28' | translate }}</b>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy29' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy30' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy31' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy32' | translate }}</p>
      <p *ngIf="isFrench">{{ 'TermsOfUse.TermsPrivacyCopy73' | translate }} <u style="color:#00566A;">{{ 'TermsOfUse.TermsPrivacyCopy74' | translate }}</u> {{ 'TermsOfUse.TermsPrivacyCopy75' | translate }}</p> 
      <p >{{ 'TermsOfUse.TermsPrivacyCopy33' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy34' | translate }}</b><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy35' | translate }}</p>

      <p *ngIf="isFrench">{{ 'TermsOfUse.TermsPrivacyCopy84' | translate }}</p>
      <p *ngIf="isFrench">{{ 'TermsOfUse.TermsPrivacyCopy85' | translate }}</p>

      <p>{{ 'TermsOfUse.TermsPrivacyCopy36' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy37' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy38' | translate }}</b><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy39' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy40' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy41' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy42' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy43' | translate }}</p>
      <p><b>{{ 'TermsOfUse.TermsPrivacyCopy45' | translate }}</b></p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy44' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy46' | translate }}</p>
      <p *ngIf="!isFrench">{{ 'TermsOfUse.TermsPrivacyCopy47' | translate }}</p>
      <p *ngIf="isFrench">{{ 'TermsOfUse.TermsPrivacyCopy81' | translate }}<a *ngIf="isFrench" href="https://daimler-truckfinancial.com/ca/fr/home"><u>{{ 'TermsOfUse.TermsPrivacyCopy82' | translate }}</u></a>{{ 'TermsOfUse.TermsPrivacyCopy83' | translate }}</p>
      <p><b>{{ 'TermsOfUse.TermsPrivacyCopy48' | translate }}</b></p>     
      <p>{{ 'TermsOfUse.TermsPrivacyCopy49' | translate }}</p>
    
      <p>{{ 'TermsOfUse.TermsPrivacyCopy50' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy51' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy52' | translate }}</p>
      <!--<p>{{ 'TermsOfUse.TermsPrivacyCopy53' | translate }}</p>-->
      <p>{{ 'TermsOfUse.TermsPrivacyCopy54' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy55' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy56' | translate }}</p><br>
      <b>{{ 'TermsOfUse.TermsPrivacyCopy57' | translate }}</b>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy58' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy59' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy60' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy61' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy62' | translate }}</p>
     <!--<p>{{ 'TermsOfUse.TermsPrivacyCopy63' | translate }}</p>--> 
      <p>{{ 'TermsOfUse.TermsPrivacyCopy64' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy65' | translate }}</p>
      <div  style="display:flex;">
      <u>{{ 'TermsOfUse.TermsPrivacyCopy71' | translate }}</u><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy72' | translate }}</p></div>
      <div  style="display:flex;">
      <u>{{ 'TermsOfUse.TermsPrivacyCopy66' | translate }}</u><br>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy67' | translate }}</p></div>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy68' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy69' | translate }}</p>
      <p>{{ 'TermsOfUse.TermsPrivacyCopy70' | translate }}</p>
    </div>
  </div>
 